<template>
    <div class="tabsContainer">
        <div class="tabs">
            <el-tabs v-if="openTab.length>0"
                     v-model="index"
                     @tab-click="tabClick"
                     @tab-remove="tabRemove"
                     type="card">
                <el-tab-pane v-for="(item) in openTab"
                             :key="item.menuId"
                             :label="item.menuName"
                             :name="item.menuUrl"
                             :closable="item.menuUrl != '/main'?true:false">
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="moreTabs">
            <el-dropdown placement="bottom" @command="changeTabs" size="medium"
                         style="color: #547bd5">
                <el-button type="primary" size="medium" style="margin-top: -15px;background-color: #547bd5">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-close" command="close-current">关闭当前
                    </el-dropdown-item>
                    <el-dropdown-item icon="el-icon-circle-close" command="close-other">关闭其他
                    </el-dropdown-item>
                    <el-dropdown-item icon="el-icon-error" command="close-all">关闭全部</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: ['openTab', 'actIndex'],
        data() {
            return {
                index: ""
            }
        },
        methods: {
            tabClick() {
                this.$emit("tabClick", this.index);
            },
            tabRemove(targetName) {
                this.$emit("tabRemove", targetName);
            },
            changeTabs(command) {
                this.$emit("changeTabs", command);
            }
        },
        watch: {
            actIndex: {
                immediate: true,
                handler: function (nv, ov) {
                    this.index = nv;
                }
            }
        }
    }
</script>
<style scoped>
    .tabsContainer{
        position: relative;
        margin-top: 2px;
        width:100%;
    }
    .tabs {
        float:left;
        width: calc(100% - 90px);
        height: 30px;
        position: relative;
        /*margin: 0 15px;*/
    }

    .moreTabs {
        float:right;
        margin-top: 7px;
    }

    /* 样式重写 tabs下边框不需要*/
    /deep/ .el-tabs--card > .el-tabs__header {
      border: none;
    }

    /deep/ .el-tabs__nav-scroll {
      background: none !important;
      border: none !important;
    }
    /deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border: none;
    }

    /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
      border: 1px solid #bbcaee;
    }

    /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
      border-left: 1px solid #bbcaee;
    }

    /deep/ .el-tabs__item {
      height:36px;
      line-height: 35px;
      color: #547bd5;
      padding: 0 15px;
      box-sizing: border-box;
      background-color: #eef2fb;
      border: 1px solid #bbcaee;
      margin-right: 5px;
        border-radius: 4px;
    }
    /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      /*border: none;*/
    }

    /deep/ .el-tabs__item.is-active {
      color: #ffffff;
      background-color: #547bd5;
    }

    /deep/ .el-tabs__nav-prev{
        border: 1px solid #bbcaee;
        position: absolute;
        cursor: pointer;
        line-height: 28px;
        height: 28px;
        font-size: 12px;
        color: #909399;
    }

    /deep/ .el-tabs__nav-next{
        border: 1px solid #bbcaee;
        position: absolute;
        cursor: pointer;
        line-height: 28px;
        height: 28px;
        font-size: 12px;
        color: #909399;
    }

    /deep/ .el-tabs__nav-prev:hover{
        background-color: #547bd5;
    }
    /deep/ .el-tabs__nav-next:hover{
        background-color: #547bd5;
    }
</style>